
const mutations = {
  setAttendeeSettings(state, payload) {
    state.attendeeSettings = payload.attendeeSettings;
  },

  setOrganizerSettings(state, payload) {
    state.organizerSettings = payload.organizerSettings;
  }
};

const state = () => ({
  attendeeSettings: null,
  organizerSettings: null
});

export default {
  namespaced: true,
  mutations,
  state
};
